import * as React from "react";
import { useLocation } from "react-router-dom";

interface PageTitleProps {
  title: string;
}

const PageTitle = ({ title }: PageTitleProps) => {
  const location = useLocation();

  React.useEffect(() => {
    document.title = title;
  }, [location, title]);

  return null;
};

export default PageTitle;
